module.exports = __webpack_public_path__ + "static/media/heather.a5e8d3bc.png";